export const environment = {
  production: false,
  apiBaseUrl: 'https://demoarea.stdapi.co.uk/api',
  apiBaseUrlForPDF: 'https://demoarea.stdapi.co.uk/api',
};
